import {
  PRIMARY_LANGUAGE_CODE,
  PRIMARY_LOCALES,
  SECONDARY_LANGUAGE_CODE,
  SECONDARY_LOCALES,
} from '../../constants';
export const getLocales = (locale: string) => {
  if (locale === PRIMARY_LANGUAGE_CODE) return PRIMARY_LOCALES;
  if (locale === SECONDARY_LANGUAGE_CODE) return SECONDARY_LOCALES;
};
